// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pad {
    padding: 10px;
    width: calc(100% - 20px);
    height: calc(100% - 20px);
}

.dmStack {
    border-right: 1px solid lightgray;
    padding-right: 1%;
    margin-right: 1%;
}

.dmTree {
    flex: 1 1 auto;
    overflow: auto;
    background: transparent;
}

.treeNode {
    padding-right: 15px;
    height: 50px;
}

.parentNode {
    cursor: default;
}

.childNode {
    cursor: pointer;
}

    .childNode:hover {
        background-color: grey;
    }

.selectedNode, .selectedNode:hover {
    background-color: var(--primary-color);
}

.settingsDIV {
    overflow: hidden;
}`, "",{"version":3,"sources":["webpack://./src/app/settings/datamodel/datamodel.settings.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,wBAAwB;IACxB,yBAAyB;AAC7B;;AAEA;IACI,iCAAiC;IACjC,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,cAAc;IACd,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;IAEI;QACI,sBAAsB;IAC1B;;AAEJ;IACI,sCAAsC;AAC1C;;AAEA;IACI,gBAAgB;AACpB","sourcesContent":[".pad {\n    padding: 10px;\n    width: calc(100% - 20px);\n    height: calc(100% - 20px);\n}\n\n.dmStack {\n    border-right: 1px solid lightgray;\n    padding-right: 1%;\n    margin-right: 1%;\n}\n\n.dmTree {\n    flex: 1 1 auto;\n    overflow: auto;\n    background: transparent;\n}\n\n.treeNode {\n    padding-right: 15px;\n    height: 50px;\n}\n\n.parentNode {\n    cursor: default;\n}\n\n.childNode {\n    cursor: pointer;\n}\n\n    .childNode:hover {\n        background-color: grey;\n    }\n\n.selectedNode, .selectedNode:hover {\n    background-color: var(--primary-color);\n}\n\n.settingsDIV {\n    overflow: hidden;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
